import router from '@/router';
import GetPolicyInfo from '@/routing/GetPolicyInfo'; // Get policy information on route change
import store from '@/store';
import * as Sentry from '@sentry/browser';

router.beforeEach(async (to, from, next) => {
	if (window.isLoggedIn) {
		try {
			await GetPolicyInfo();
		} catch (e) {
			Sentry.captureException(e);
		}
	}

	store.dispatch('Misc/setLoading', false);
	next();
});
